module.exports = __webpack_public_path__ + "static/media/ls.f569fcb1.svg";